import React from 'react'
import { altinSponsorlar } from "./AltinSponsorlar";
import { Button, Card, CardBody, CardSubtitle, CardText, CardTitle } from 'reactstrap';

export default function AltinSponsorCard()
{
    return (
        <div class="container mt-3">
            <div class="row my-3 paydasCard sponsorCard sponsor">
                {
                    altinSponsorlar.map((sponsor, index) => (
                        <div class="col-md-4 my-3 text-center" key={index}>
                            <Card>
                                <div class="paydasImg">
                                    <img
                                        width="150px"
                                        alt={sponsor?.name}
                                        src={sponsor?.imageUrl}
                                    />
                                </div>
                                <CardBody>
                                    <a target='_blank' href={sponsor?.url}>
                                        {sponsor?.name}
                                    </a>
                                </CardBody>
                            </Card>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}
